import * as React from "react"
import colors from "../../theme/colors"

interface Props {
  isActive: boolean
  color: string
}

const Menu: React.SFC<Props> = ({ isActive, color }) => (
  <svg width={24} height={24}>
    <path
      d={
        isActive
          ? "M18.3 5.71a.996.996 0 00-1.41 0L12 10.59 7.11 5.7A.996.996 0 105.7 7.11L10.59 12 5.7 16.89a.996.996 0 101.41 1.41L12 13.41l4.89 4.89a.996.996 0 101.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
          : "M4 18h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z"
      }
      fill={isActive ? colors.additional.greyColor.TUNDORA : color}
    />
  </svg>
)

export default Menu
